var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-new main-padding"},[(_vm.projectStep == 1)?_c('CProductSelector',{attrs:{"current_user":_vm.current_user}}):_c('CVideoNew',{attrs:{"current_user":_vm.current_user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }